import { Link } from "react-router-dom";
import closeModal from "../../assets/images/closeModal.png";
import Search from "../../assets/images/Search1.png";
import arrow from "../../assets/images/arrow_down.svg";
import { Countriesdata } from "../../constants/CountriesData";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import x from "../../assets/images/X.png";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import {
  GetCountryCode,
  SelectedCurrencies,
} from "../../features/Currency/CurrencySlice";
import { Currency } from "../Bags/Currency";
import { Modal } from "react-bootstrap";

function LocationModal({ showLocation, setShowLocation, id }) {
  const dispatch = useDispatch();
  //const { searchCountires } = useSelector((store) => store.flags);
  const { t, i18n } = useTranslation();
  const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
  const { countryCode } = useSelector((store) => store.currency);
  const { currencies, selectedcurrency, currencydefault } = useSelector(
    (store) => store.currency
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);
  const [isDropdownOpen2, setIsDropdownOpen2] = useState(false);
  const [country, setCountry] = useState("");
  const [code, setCode] = useState(countryCode);
  const [currency, setCurrency] = useState(
    selectedcurrency ? currencydefault : selectedcurrency
  );
  const [language, setLanguage] = useState(i18n.language == "ar" ? "ar" : "en");
  const [searchCountires, setSearchCountires] = useState("");
  const [searchCurrency, setSearchCurrency] = useState("");
  const [searchLangage, setSearchLanguage] = useState("");
  const sortCountries = (a, b) => {
    const topCountries = ["United Arab Emirates", "Saudi Arabia", "Lebanon"];
    const indexOfA = topCountries.indexOf(a.name);
    const indexOfB = topCountries.indexOf(b.name);
    if (indexOfA !== -1 && indexOfB !== -1) {
      return indexOfA - indexOfB;
    } else if (indexOfA !== -1) {
      return -1;
    } else if (indexOfB !== -1) {
      return 1;
    } else {
      return a.name.localeCompare(b.name);
    }
  };
  const sortedCountries = [...Countriesdata].sort(sortCountries);
  const filtered = !searchCountires
    ? sortedCountries
    : i18n.language === "en"
    ? sortedCountries.filter(
        (con) =>
          con.name &&
          con.name.toLowerCase().includes(searchCountires.toLowerCase())
      )
    : sortedCountries.filter(
        (con) =>
          con.nameAr &&
          con.nameAr.toLowerCase().includes(searchCountires.toLowerCase())
      );

  const handleToggle = (isOpen) => {
    setIsDropdownOpen(!isOpen);
  };
  const handleToggle1 = (isOpen) => {
    setIsDropdownOpen1(!isOpen);
  };
  const handleToggle2 = (isOpen) => {
    setIsDropdownOpen2(!isOpen);
  };

  const filteredCurrency = !searchCurrency
    ? currencies
    : i18n.language === "en"
    ? currencies.filter(
        (con) =>
          con.name &&
          con.name.toLowerCase().includes(searchCurrency.toLowerCase())
      )
    : currencies.filter(
        (con) =>
          con.nameAr &&
          con.nameAr.toLowerCase().includes(searchCurrency.toLowerCase())
      );

  const handleOnSelectCountry = async (code) => {
    setCode(code);
    dispatch(GetCountryCode(code));
    setCountry(regionNames.of(code));
    setIsDropdownOpen(!isDropdownOpen);
  };
  const handleOnSelectCurrency = async (currency) => {
    setCurrency(currency);
    dispatch(SelectedCurrencies(currency));
    dispatch(GetCountryCode(code));
    setIsDropdownOpen1(!isDropdownOpen1);
  };
  const handleOnSelectLangauge = async (language) => {
    setLanguage(language);
    var e = true;
    if (language == "en") {
      e = true;
    } else {
      e = false;
    }
    localStorage.setItem("language", e);
    if (e == true) {
      document.body.dir = i18n.dir("en");
      i18n.changeLanguage("en");
    } else {
      i18n.changeLanguage("ar");
      document.body.dir = i18n.dir("ar");
    }
    setIsDropdownOpen2(!isDropdownOpen2);
  };
  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
      textAlign: "right",
    };
  } else {
    var arabStyle = {};
  }
  if (i18n.language == "ar") {
    var arabStyles = {
      letterSpacing: "0em",
      textAlign: "right",
    };
  } else {
    var arabStyles = {};
  }
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Become a seller and get paid. Sell pre-loved luxury fashion, from pre-loved designer bags, shoes and accessories of Gucci, Louis Vuitton, Prada and more."
        />
        <title>Sell Luxury Fashion Dubai - Libas</title>
      </Helmet>
      <Modal
        // className="modal fade"
        // id="SignUp"
        // tabIndex="-1"
        // role="dialog"
        // aria-labelledby="SignUp"
        show={showLocation}
        size="xlg"
        className="modal fade"
        centered
      >
        {/* <div
          className="modal-dialog modal-dialog-centered modal-signup"
          role="document"
        > */}
        <Modal.Body className="p-0 m-0 ">
          {/* <div
        className="d-md-block custom-modal"
        id={id}
        tabIndex="-1"
        role="dialog"
        aria-labelledby={id}
        data-bs-backdrop="static"
      > */}
          {/* <div className=" position-relative "> */}
          {/* <div
            className="modal-locations"
            role="document"
          > */}
          {/* <div
              className="bg-white"
              style={{ borderRadius: "0px" }}
            > */}
          {/* <img src={downloadImgModal} className="w-100 "/> */}
          <div className="  px-4 pb-4  w-100">
            {/* <div className="justify-content-end d-flex position-btndownload">
        <button type="button" className="close close-txt close-modal align-items-center px-0" data-dismiss="modal" aria-label="Close" onClick={()=>setShow(false)}>
      
        <img src={x} onClick={()=>setShow(false)} className="x-close ms-1 mb-1"/>
        </button>
        </div> */}
            <div className="position-locationtxt">
              <div
                className={`pt-2 pb-1 download-modal-title  ${
                  i18n.language == "en" ? "text-start" : "text-startAr"
                } `}
                style={arabStyle}
              >
                {/* {t("DOWNLOADLIBAS")} */}
                {t("SelectYourCountry")}
                {/* Select Your Country */}
              </div>
              <span className="align-items-center d-flex justify-content-between">
                <div
                  className="w-100 px-lg-0 bg-white"
                  style={{ border: "solid", borderWidth: "1px" }}
                >
                  <div
                    class="dropdown align-items-center d-flex"
                    style={{ height: "36px" }}
                  >
                    <button
                      onClick={() => handleToggle(isDropdownOpen)}
                      class="align-items-center d-flex  dropdown-toggle w-100 selectedcountrytitle  bg-transparent"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      aria-label="Select Country"
                    >
                      <div className="justify-content-between d-flex align-items-center w-100 ">
                        <div className="d-flex align-items-center ">
                          {Countriesdata.filter(
                            (coun) => coun.code == code
                          ).map((con) =>
                            i18n.language == "en" ? (
                              <>
                                {con.flag}{" "}
                                <span className="px-2">{con.name}</span>
                              </>
                            ) : (
                              <>
                                {con.flag}{" "}
                                <span className="px-2">{con.nameAr}</span>
                              </>
                            )
                          )}
                        </div>
                        <div>
                          {isDropdownOpen ? (
                            <img
                              alt="main"
                              src={arrow}
                              className={` mb-1  arrowsort`}
                            />
                          ) : (
                            <img
                              alt="main"
                              src={arrow}
                              className={`mb-1  arrowsort2`}
                            />
                          )}
                        </div>
                      </div>
                    </button>

                    <ul
                      class="dropdown-menu dropdowncountry"
                      aria-labelledby="dropdownMenuButton1"
                      style={{
                        overflow: "auto",
                        height: "300px",
                        width: "100%",
                      }}
                    >
                      <div className=" border-0  bg-transparent dropdown-toggle shopping-bag-btn">
                        <div className="input-group ">
                          <span
                            className={`input-group-text  input-group-textfa  ${
                              i18n.language == "en"
                                ? "fa-searchicon"
                                : "fa-searchiconAr"
                            }`}
                            id="basic-addon1"
                          >
                            <img
                              alt="main"
                              src={Search}
                              className="fa-search-brand2country"
                            />
                          </span>
                          <input
                            type="text"
                            className={` px-3 px-md-0 form-control  ${
                              i18n.language == "en"
                                ? "search-brand2"
                                : "search-brand2Ar"
                            }`}
                            placeholder={t("Searchforyourcountry")}
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            onChange={(e) =>
                              //dispatch(SetSearchCountires(e.target.value))
                              setSearchCountires(e.target.value)
                            }
                            value={searchCountires}
                          />
                        </div>
                      </div>

                      {filtered.map((con) => (
                        <div
                          onClick={() => handleOnSelectCountry(con.code)}
                          className={
                            i18n.language == "en"
                              ? `selectedcountry `
                              : `selectedcountry selectedcountryAr`
                          }
                        >
                          {con.flag}
                          <span className="px-3">
                            {i18n.language == "en" ? con.name : con.nameAr}
                          </span>
                        </div>
                      ))}
                    </ul>
                  </div>
                </div>
              </span>
            </div>
            <div className="position-locationtxt">
              <div
                className={`pt-2 pb-1 download-modal-title  ${
                  i18n.language == "en" ? "text-start" : "text-startAr"
                } `}
                style={arabStyle}
              >
                {/* {t("DOWNLOADLIBAS")} */}
                {t("SelectYourCurrency")}
                {/* Select Your Currency */}
              </div>
              <span className="align-items-center d-flex justify-content-between">
                <div
                  className="w-100 px-lg-0 bg-white"
                  style={{ border: "solid", borderWidth: "1px" }}
                >
                  <div
                    class="dropdown align-items-center d-flex"
                    style={{ height: "36px" }}
                  >
                    <button
                      onClick={() => handleToggle1(isDropdownOpen1)}
                      class="align-items-center d-flex  dropdown-toggle w-100 selectedcountrytitle  bg-transparent"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      aria-label="Select Country"
                    >
                      <div className="justify-content-between d-flex align-items-center w-100 ">
                        <div className="d-flex align-items-center ">
                          {filteredCurrency
                            .filter((curr) => {
                              if (selectedcurrency) {
                                return curr.id === selectedcurrency;
                              } else {
                                return curr.id === currencydefault;
                              }
                            })
                            .map((con) =>
                              i18n.language == "en" ? (
                                <>
                                  <span className="px-2">{con.name}</span>
                                </>
                              ) : (
                                <>
                                  <span className="px-2">{con.nameAr}</span>
                                </>
                              )
                            )}
                        </div>
                        <div>
                          {isDropdownOpen1 ? (
                            <img
                              alt="main"
                              src={arrow}
                              className={` mb-1  arrowsort`}
                            />
                          ) : (
                            <img
                              alt="main"
                              src={arrow}
                              className={`mb-1  arrowsort2`}
                            />
                          )}
                        </div>
                      </div>
                    </button>

                    <ul
                      class="dropdown-menu dropdowncountry"
                      aria-labelledby="dropdownMenuButton1"
                      style={{
                        overflow: "auto",
                        height: "300px",
                        width: "100%",
                      }}
                    >
                      <div className=" border-0  bg-transparent dropdown-toggle shopping-bag-btn">
                        <div className="input-group ">
                          <span
                            className={`input-group-text  input-group-textfa  ${
                              i18n.language == "en"
                                ? "fa-searchicon"
                                : "fa-searchiconAr"
                            }`}
                            id="basic-addon1"
                          >
                            <img
                              alt="main"
                              src={Search}
                              className="fa-search-brand2country"
                            />
                          </span>
                          <input
                            type="text"
                            className={` px-3 px-md-0 form-control  ${
                              i18n.language == "en"
                                ? "search-brand2"
                                : "search-brand2Ar"
                            }`}
                            placeholder={t("Selectforyourcurrency")}
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            onChange={(e) =>
                              //dispatch(SetSearchCountires(e.target.value))
                              setSearchCurrency(e.target.value)
                            }
                            value={searchCurrency}
                          />
                        </div>
                      </div>

                      {filteredCurrency.map((cur) => (
                        <div
                          onClick={() => handleOnSelectCurrency(cur.id)}
                          className={
                            i18n.language == "en"
                              ? `selectedcountry `
                              : `selectedcountry selectedcountryAr`
                          }
                        >
                          <span className="px-3">
                            {i18n.language == "en" ? cur.name : cur.nameAr}
                          </span>
                        </div>
                      ))}
                    </ul>
                  </div>
                </div>
              </span>
            </div>
            <div className="position-locationtxt">
              <div
                className={`pt-2 pb-1 download-modal-title  ${
                  i18n.language == "en" ? "text-start" : "text-startAr"
                } `}
                style={arabStyle}
              >
                {/* {t("DOWNLOADLIBAS")} */}
                {t("SelectYourLanguage")}
                {/* Select Your Language */}
              </div>
              <span className="align-items-center d-flex justify-content-between">
                <div
                  className="w-100 px-lg-0 bg-white"
                  style={{ border: "solid", borderWidth: "1px" }}
                >
                  <div
                    class="dropdown align-items-center d-flex"
                    style={{ height: "36px" }}
                  >
                    <button
                      onClick={() => handleToggle2(isDropdownOpen2)}
                      class="align-items-center d-flex  dropdown-toggle w-100 selectedcountrytitle  bg-transparent"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      aria-label="Select Country"
                    >
                      <div className="justify-content-between d-flex align-items-center w-100 ">
                        <div className="d-flex align-items-center ">
                          {[
                            {
                              name: "English US",
                              id: "en",
                              nameAr: "الانجليزية",
                            },
                            { name: "Arabic", id: "ar", nameAr: "العربية" },
                          ]
                            .filter((lan) => lan.id == language)
                            .map((con) =>
                              i18n.language == "en" ? (
                                <>
                                  {con.flag}{" "}
                                  <span className="px-2">{con.name}</span>
                                </>
                              ) : (
                                <>
                                  {con.flag}{" "}
                                  <span className="px-2">{con.nameAr}</span>
                                </>
                              )
                            )}
                        </div>
                        <div>
                          {isDropdownOpen2 ? (
                            <img
                              alt="main"
                              src={arrow}
                              className={` mb-1  arrowsort`}
                            />
                          ) : (
                            <img
                              alt="main"
                              src={arrow}
                              className={`mb-1  arrowsort2`}
                            />
                          )}
                        </div>
                      </div>
                    </button>

                    <ul
                      class="dropdown-menu dropdowncountry"
                      aria-labelledby="dropdownMenuButton1"
                      style={{
                        overflow: "auto",
                        height: "300px",
                        width: "100%",
                      }}
                    >
                      {/* <div className=" border-0  bg-transparent dropdown-toggle shopping-bag-btn">
                            <div className="input-group ">
                              <span
                                className={`input-group-text  input-group-textfa  ${
                                  i18n.language == "en"
                                    ? "fa-searchicon"
                                    : "fa-searchiconAr"
                                }`}
                                id="basic-addon1"
                              >
                                <img
                                  src={Search}
                                  className="fa-search-brand2country"
                                />
                              </span>
                              <input
                                type="text"
                                className={` px-3 px-md-0 form-control  ${
                                  i18n.language == "en"
                                    ? "search-brand2"
                                    : "search-brand2Ar"
                                }`}
                                placeholder={t("placeholderSeacrh")}
                                aria-label="Username"
                                aria-describedby="basic-addon1"
                                onChange={(e) =>
                                  //dispatch(SetSearchCountires(e.target.value))
                                  setSearchLanguage(e.target.value)
                                }
                                value={searchLangage}
                              />
                            </div>
                          </div> */}

                      {[
                        { name: "English US", id: "en", nameAr: "الانجليزية" },
                        { name: "Arabic", id: "ar", nameAr: "العربية" },
                      ].map((lan) => (
                        <div
                          onClick={() => handleOnSelectLangauge(lan.id)}
                          className={
                            i18n.language == "en"
                              ? `selectedcountry `
                              : `selectedcountry selectedcountryAr`
                          }
                        >
                          <span className="px-3">
                            {i18n.language == "en" ? lan.name : lan.nameAr}
                          </span>
                        </div>
                      ))}
                    </ul>
                  </div>
                </div>
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-center ">
            <div
              onClick={() =>
                setShowLocation(!showLocation) && dispatch(GetCountryCode(code))
              }
              className="location-set-btn"
              style={arabStyles}
            >
              {t("set")}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* </div> */}
      {/* </div> */}
      {/* </div> */}
      {/* </div> */}
    </>
  );
}

export default LocationModal;
